import React from 'react'
import MainLayout from '../../layout/MainLayout'
import PropertyView from '../../components/property/PropertyView'

const PropertyViewPage = () => {
  return (
    <MainLayout>
        <PropertyView />
    </MainLayout>
  )
}

export default PropertyViewPage